// extracted by mini-css-extract-plugin
export default {"icon":"checkout-pages_icon__jUaqy","title":"checkout-pages_title__vlGwi","container":"checkout-pages_container__SR+Sg","bookingDetails":"checkout-pages_bookingDetails__IgWcW"};